import { render, staticRenderFns } from "./ModifyOrArchiveDevis.vue?vue&type=template&id=deb1cd94&"
import script from "./ModifyOrArchiveDevis.vue?vue&type=script&lang=js&"
export * from "./ModifyOrArchiveDevis.vue?vue&type=script&lang=js&"
import style0 from "./ModifyOrArchiveDevis.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports